/**
 * Upcoming live dates for paid offers. Change dates HERE only.
 * Dates are recommendations — confirm with Dr. Sully before promoting.
 */
import { OFFERS } from "@/content/offers";

export const NEXT_MASTERCLASS = {
  /** ISO with Central offset. */
  startsAt: "2026-10-15T19:00:00-05:00",
  durationMin: 90,
  platform: "Live on Zoom",
  timezoneLabel: "Central Time",
  priceId: OFFERS.masterclass.priceId!,
};

export const STRATEGY_SESSION = {
  durationMin: 60,
  platform: "Zoom or phone",
  priceId: OFFERS.session.priceId!,
  priceLabel: OFFERS.session.priceLabel,
};

export function formatEventDate(iso: string) {
  const d = new Date(iso);
  const date = d.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", timeZone: "America/Chicago" });
  const time = d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", timeZone: "America/Chicago" });
  return { date, time: `${time} CT` };
}
